export { BaseCommentBody } from './BaseCommentBody';
export type { BaseCommentBodyProps } from './BaseCommentBody.types';
